import ActionTypes    from '../../ActionTypes';
import {
    UserSession,
    Contact
}                     from '../../types';
import contactService from '../../services/ContactService';
import dncService from '../../services/DncService';

const loadingContact = () => ({
    type: ActionTypes.CONTACT_LOADING
});

const loadContactSuccess = (contact: Contact, id: number) => ({
    type: ActionTypes.CONTACT_LOADED,
    contact,
    id
});

const loadContactError = (error: TypeError) => ({
    type: ActionTypes.CONTACT_LOAD_ERROR,
    error
});

export const loadContact = (user: UserSession, banId: string, contactId: number) => async (dispatch) => {
    dispatch(loadingContact());

    try {
        const contact = await contactService(banId, contactId, user.token);
        const isDnc = await dncService(banId, user.token);

        contact.isDnc = (isDnc[banId]) ? isDnc[banId] : false;

        dispatch(loadContactSuccess(contact, contactId));
    } catch (error) {
        dispatch(loadContactError(error));
    }
};



// WEBPACK FOOTER //
// ./src/sections/Contact/ContactActions.ts